<div class="row col-12 justify-content-between m-0 mb-2 pr-0">
    <!-- ng-content elements wrapped in divs to ensure flexbox placement -->
    <div>
        <ng-content select="kno2-grid-page-size-select"></ng-content>
    </div>
    <div>
        <ng-content select="kno2-grid-search"></ng-content>
    </div>
</div>
<div
    [nbSpinner]="isLoading"
    class="w-100">
    <ag-grid-angular
        style="height: 500px"
        class="ag-theme-material"
        [gridOptions]="options"
        [rowData]="rowData"
        [columnDefs]="options.columnDefs"
        [pagination]="!!pagingOptions"
        [paginationPageSize]="pagingOptions?.pageSize"
        [components]="frameworkComponents"
        overlayNoRowsTemplate="No results available"
        overlayLoadingTemplate="Loading..."
        suppressBrowserResizeObserver="true"
        (paginationChanged)="handlePaginationChange($event)"
        (sortChanged)="handleSortChange($event)"
        (selectionChanged)="onSelectionChange()"
        (filterChanged)="handleFilterChange($event)"
        (gridReady)="onDataGridReady($event)"
        (firstDataRendered)="onFirstDataRendered()"></ag-grid-angular>
</div>
